import '../css/returns.scss';
import $ from '@modules/jquery-import';
import Modal from '@plugins/modal';

const modal = Modal.getInstance();

window.printPage = printPage;
window.closePrint = closePrint;
window.setPrint = setPrint;
window.addedItem = addedItem;

// Print code is for opening up print window for return label and packing slip.
function closePrint () {document.body.removeChild( this.__container__ ); }

function setPrint () {
    this.contentWindow.__container__ = this;
    this.contentWindow.onbeforeunload = closePrint;
    this.contentWindow.onafterprint = closePrint;
    this.contentWindow.focus(); // Required for IE
    this.contentWindow.document.execCommand( 'print', false, null ); // Required for IE
    this.contentWindow.print();
}

function printPage ( sURL ) {
    var oHiddFrame = document.createElement( 'iframe' );
    oHiddFrame.onload = setPrint;
    oHiddFrame.style.visibility = 'hidden';
    oHiddFrame.style.position = 'fixed';
    oHiddFrame.style.right = '0';
    oHiddFrame.style.bottom = '0';
    oHiddFrame.src = sURL;
    document.body.appendChild( oHiddFrame );
}

// This is called from codebehind when they add items. This will open a modal popup of the item they are returning.
function addedItem ( itemIndex, totalCount ) {
    const modalContent = function () {
        const block = $( '#item-id-' + itemIndex )
            .closest( '.item-container' )
            .children( '.item-title' )
            .html();
        const actions = $( '.modal-actions' ).html();

        return `
            <div class="modal-pop modal-added-item">
                <h2 class="msg-confirmation">
                    <i class="icon-ok-circle"></i>
                    ${totalCount} ${(totalCount > 1) ? 'Items' : 'Item'}
                    added to your returns list!
                </h2>
                ${block}
            </div>
            <footer class="qv-summary qv-order-summary">
                <div class="grid-unit">
                    <div class="buttonList">${actions}</div>
                </div>
            </footer>
        `;
    };

    modal.open( {
        content: modalContent(),
        width: 640
    } );
}

$( document ).ready( function () {
    // todo -> determine if this is still needed
    // the buttons inside of modal will not work, so move the modal content inside of form to cause postback.
    // $( '#colorbox, #cboxOverlay' ).appendTo( 'form:first' );

    // this code will open the item's select quantity to return
    var acc = document.getElementsByClassName( 'start-return' );
    for ( let i = 0; i < acc.length; i++ ) {
        acc[i].onclick = function () {
            this.classList.toggle( 'active' );
            this.nextElementSibling.classList.toggle( 'show' );
        }
    }

    // On Load open all items if item has been added
    $( '.target' )
        .each( function ( index ) {
            if ( this.value > 0 ) {
                var parentLotItemBlock = $( this ).closest( '.lot-item-block' );
                parentLotItemBlock.prev().addClass( 'active' ); // get previous sibling "start-return"
                parentLotItemBlock.addClass( 'show' );

                var parentLotItem = $( this ).closest( '.lot-item' );
                parentLotItem.children( '.edit-items' ).css( 'display', 'none' );
                parentLotItem.children( '.added-items' ).css( 'display', 'block' );
                parentLotItem.children( '.added-actions' ).css( 'display', 'block' );
            }
        } )
        .on( 'change', function () {
            $( this )
                .closest( '.edit-items' )
                .children( '.sub-edit-items' )
                .css( 'display', this.value > 0 ? 'block' : 'none' );
        } );

    // When user chooses "Opened" as cchangeLocationondition of item
    $( '.item-condition' ).on( 'change', function () {
        if ( this.value == 2 ) {
            modal.open( {target: '#item-condition-modal'} );
        }
    } );

    // When user selects quantity of items to return open rest of questions
    // When user clicks on add button close questions and open summary of what was added.
    $( '.add-btn' ).on( 'click', function () {
        var qty = $( this ).closest( '.edit-items' ).find( '.target' ).val();
        $( this )
            .closest( '.edit-items' )
            .children( '.added-items' )
            .css( 'display', qty > 0 ? 'block' : 'none' );
    } );

    $( '.add-btn, .remove-btn' ).click( function () {
        var url = $( this ).attr( 'href' );
        $( '#aspnetForm' ).attr( 'action', url );
        $( '#aspnetForm' ).attr( 'method', 'POST' );
        $( '#aspnetForm' ).submit();
        return false;
    } );

    $('#print_button').click(function () {
        window.print();
    });

    // When user clicks edit, open the questions again and the add button
    $( '.edit-btn' ).on( 'click', function () {
        var parentLotItem = $( this ).closest( '.lot-item' );
        parentLotItem.children( '.edit-items' ).toggle();
        parentLotItem.children( '.edit-items' ).children( '.sub-edit-items' ).toggle();
        parentLotItem.children( '.added-items' ).toggle();
        parentLotItem.children( '.added-actions' ).toggle();
        return false;
    } );
} );
